const state = {
  componentData: null,
  language: null
}

const mutations = {
  'UPDATE_DATA' (state, value) {
    state.componentData = value
  },
  'UPDATE_LANGUAGE' (state, value) {
    state.language = value
  }
}

const actions = {
  setComponentData ({ commit }, body) {
    commit('UPDATE_DATA', body)
  },
  setLanguage ({ commit }, body) {
    commit('UPDATE_LANGUAGE', body)
  }
}

const getters = {
  componentData (state) {
    return state.componentData
  },
  language (state) {
    return state.language
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
